import { kaggleTierLabels, kaggleTierOrder } from "../data/kaggleTiers";

export function KaggleTierLegend() {
  return (
    <aside
      className="kaggle-tier-legend"
      aria-labelledby="kaggle-tier-legend-title"
    >
      <div className="kaggle-tier-legend-copy">
        <span>KAGGLE TIERS</span>
        <h3 id="kaggle-tier-legend-title">Kaggle称号と名前の色</h3>
        <p>
          Kaggle公開プロフィールから取得した称号です。AIYSS独自のランクではなく、ランキング内の名前を取得した称号の色で表示しています。
        </p>
      </div>
      <ul aria-label="Kaggle称号の色一覧">
        {kaggleTierOrder.map((tier) => (
          <li key={tier} data-kaggle-tier={tier}>
            <i aria-hidden="true" />
            <strong>{kaggleTierLabels[tier]}</strong>
          </li>
        ))}
      </ul>
    </aside>
  );
}
